module.exports = __webpack_public_path__ + "3a5762bd64bafdbe776660954a5a3c31.svg";